// Copyright (c) 2016 Deere & Company

import actions from '../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>
    dispatch => {

        dispatch({
            data: claim,
            isCopied: true,
            type: actions.COPY_CLAIM_MASS_CHANNEL_PDI
        });

        dispatch(routerActions.replace('/claims/mass-channel-pdi/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/copy-claim.js